import { Box } from '@mui/material';
import React from 'react';

export interface ManifestScreenshotData {
    id: number;
    stage_name: string;
    stage_number: number;
    url_key: string;
    role: string;
    title: string;
    description: string;
    light_mobile: string | null;
    light_ipad: string | null;
    light_desktop: string | null;
    dark_mobile: string | null;
    dark_ipad: string | null;
    dark_desktop: string | null;
}

interface ScreenshotSlideProps {
    screenshot: ManifestScreenshotData;
    imageUrl: string;
    visible: boolean;
}

const ScreenshotSlide: React.FC<ScreenshotSlideProps> = ({ screenshot, imageUrl, visible }) => {
    return (
        <Box
            component="img"
            src={imageUrl}
            alt={screenshot.title}
            sx={{
                display: visible ? 'block' : 'none',
                width: '100%',
            }}
        />
    );
};

export default ScreenshotSlide;
